module.exports = __webpack_public_path__ + "07_mole.58346439.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/07_mole.png
// module id = IoWj
// module chunks = 0